import { httpClient } from "@coworker/http-client";
import { ApiEndpoints, BackendServices } from "./EndpointsTypes";

export async function postRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices
) {
  return (await internalRequest<TBody, TResponse>(
    body,
    path,
    service,
    "POST"
  )) as TResponse;
}

export async function putRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  service: BackendServices
) {
  return (await internalRequest<TBody, TResponse>(
    body,
    path,
    service,
    "PUT"
  )) as TResponse;
}

async function internalRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  _service: BackendServices,
  requestType: string
) {
  return await baseRequest<TBody, TResponse>(body, path, _service, requestType);
}

async function baseRequest<TBody, TResponse>(
  body: TBody,
  path: ApiEndpoints,
  _service: BackendServices,
  requestType: string
) {
  if (requestType === "POST") {
    return await httpClient.mfaq.post<TResponse>(`/${path}`, { body });
  } else {
    return await httpClient.mfaq.put<TResponse>(`/${path}`, { body });
  }
}
